import React, { ReactElement } from 'react';

import { Link } from '@infoods/lifebase-ui';

import {
  GridTableCell,
  GridTableRow,
  UserInfoCell,
} from '../../../../../shared/components/table-components';
import { UnreadScansInfo } from '../../../../interfaces/UnreadScansRowInfo';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import {
  localDataFormat,
  localDateTimeFormat,
} from '../../../../../shared/constants/apiDateFormat';
import { getCustomerProfileUrl } from '../../../../utils/getCustomerProfileUrl/getCustomerProfileUrl';
import { getHumanizeSolutionType } from '../../../../../shared/utils/userInfoUtils/getHumanizeSolutionType/getHumanizeSolutionType';
import { UNREAD_SCANS_COLUMN, UnreadScansColumn } from '../UnreadScansTable.settings';
import { CUSTOMER_STATUS } from '../../../../../shared/constants/customer/customerStatus';
import { SOLUTION_TYPE } from '../../../../../shared/constants/user-info/solutionType';

type ScanRowProps = {
  scanInfo: UnreadScansInfo;
  visibleColumns: UnreadScansColumn[];
};

const ScanRow = ({ scanInfo, visibleColumns }: ScanRowProps) => {
  const {
    id,
    entityId,
    firstName,
    lastName,
    email,
    activeSince,
    dateOfUpdate,
    solutionType,
    coach,
    paymentStatus,
  } = scanInfo;

  const isPreRegistered =
    solutionType === SOLUTION_TYPE.NUTRITION &&
    paymentStatus === CUSTOMER_STATUS.PRE_REGISTERED;

  const href = isPreRegistered
    ? `#!/customer-setup/flow-2024/${id}`
    : getCustomerProfileUrl({ solutionType, entityId, customerId: id });

  const renderColumnsInfo: Record<UnreadScansColumn, ReactElement> = {
    [UNREAD_SCANS_COLUMN.NAME]: (
      <UserInfoCell firstName={firstName} lastName={lastName} email={email} href={href} />
    ),
    [UNREAD_SCANS_COLUMN.SOLUTION]: (
      <GridTableCell>{getHumanizeSolutionType(solutionType)}</GridTableCell>
    ),
    [UNREAD_SCANS_COLUMN.COACH]: (
      <GridTableCell>
        {coach ? (
          <Link href={`#!/nutrition/coach-edit/${coach.id}`}>
            {coach.firstName} {coach.lastName}
          </Link>
        ) : (
          '-'
        )}
      </GridTableCell>
    ),
    [UNREAD_SCANS_COLUMN.ACTIVE_SINCE]: (
      <GridTableCell>
        {activeSince ? getFormattedDate(activeSince, localDataFormat) : '-'}
      </GridTableCell>
    ),
    [UNREAD_SCANS_COLUMN.DATE_OF_UPDATE]: (
      <GridTableCell justify="end">
        {getFormattedDate(dateOfUpdate, localDateTimeFormat)}
      </GridTableCell>
    ),
  };

  return (
    <GridTableRow variant="subRow">
      {visibleColumns.map((column) => (
        <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
      ))}
    </GridTableRow>
  );
};

export { ScanRow };
